import { createSlice } from '@reduxjs/toolkit';
// utils
import messageSound from "../../assets/audio/message.mp3";
import { hostSocket } from '../../config/env';
// ----------------------------------------------------------------------
import { socketPromise } from './socket.io-promise';
import { useSnackbar } from 'notistack5';
import IO from "socket.io-client";
import { receiMessageFromWebhookZalo } from './conversationZalo';
import { receiMessageFromWebhookFacebook } from './conversationFacebook';
import { receiPostFromWebhookFacebook, receiCommentFromWebhookFacebook, receiCommentRepliesFromWebhookFacebook } from './postFacebook';
import { newMessage, newMessageFacebook, newMessageZalo } from './chat';
import { onMusicByType } from '../../utils/getFileSound';
import { addNotification } from './notification';
import notification from '../../api/notification';
import { onEventGuestConnectUser, onRemoveQueue, } from './widget';
import { onEventJoinChat, onEventReceiveMessage, receiMessageFromWebhookLiveChat } from './conversationLive';


const initialState = {
    io: null,
    room: null,
    messages: [],
    rooms: [],
    id: null,
    onlineUsers: [],
    refreshMeetings: null,
    notify_content: ""
};
//const {user} = useAuth();
//
// name : teen store quan li
const slice = createSlice({
    name: 'io',
    initialState,
    reducers: {
        // START LOADING
        startLoading(state) {
            state.isLoading = true;
        },
        // HAS ERROR
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },
        initializeIO(state, action) {
            state.id = action.payload.io.id;
            state.io = action.payload.io;
        },
        notify(state, action) {
            state.notify_content = action.payload.notify_content
        },
        refreshNotify(state, action) {
            state.notify_content = ""
        }


    }
});

// Reducer
export default slice.reducer;


export const InitIO = (token) => (dispatch) => {

    const notify_audio_facebook = () => {
        const user = JSON.parse(localStorage.getItem("user"));
        if (user?.notification_facebook === 1) {
            onMusicByType(user.audio_facebook_message, user.volume_facebook)
        }


    }
    const notify_audio_zalo = () => {
        const user = JSON.parse(localStorage.getItem("user"));
        if (user?.notification_zalo === 1) {
            onMusicByType(user.audio_zalo_message, user.volume_zalo)
        }

    }
    /// MARK: - Initials;
    console.log('SOCKET NEW')
    let io = IO((hostSocket || "") + "/");
    io.request = socketPromise(io);
    io.on("connect", () => {
        const user = JSON.parse(localStorage.getItem("user"));
        io.emit('add_user', user.id)
        dispatch(slice.actions.initializeIO({ io }));
    });

    io.on("authenticated", () => {

    });
    io.on('zalo-msg-recieve', data => {
        console.log(data)
        const oa_ids = JSON.parse(localStorage.getItem('oa_ids'));
        const user = JSON.parse(localStorage.getItem("user"));
        if (Array.isArray(oa_ids) && oa_ids.includes(data.oa_id) && data?.store_id === user.store_id) {
            notify_audio_zalo();
            dispatch(receiMessageFromWebhookZalo(data));
            dispatch(newMessageZalo(data));
        }
    })
    /// Message In
    io.on("message-in-zalo", (data) => {
        notify_audio_zalo();
    });
    io.on('live-msg-recieve', data => {
        const user = JSON.parse(localStorage.getItem('user'));
        if (data.from_id === user.id || data.to_id === user.id) {
            notify_audio_facebook();    
            
            dispatch(receiMessageFromWebhookLiveChat(data));
            //sdispatch(newMessageLive(data));
        }

    })
    io.on('facebook-msg-recieve', data => {
        const user = JSON.parse(localStorage.getItem("user"));
        const page_ids = JSON.parse(localStorage.getItem('page_ids'));
        if (Array.isArray(page_ids) && page_ids.includes(data.page_id) && data?.store_id === user.store_id) {
            notify_audio_facebook();
            dispatch(receiMessageFromWebhookFacebook(data));
            dispatch(newMessageFacebook(data));
        }

    })
    io.on('notification-recieve', data => {
        notify_audio_facebook();
        console.log(data)
        const user = JSON.parse(localStorage.getItem("user"));
        if ((data.permission === "personal" && user.id === data?.reciever_id) || data.permission === "all" || (data.permission === "group" && data?.department_id === user?.department_id && data?.title_id === user?.title_id)) {
            dispatch(addNotification(data))
        }
    })
    io.on('notification-ticket', data => {
        console.log(data)
        const user = JSON.parse(localStorage.getItem("user"));
        if (user.id === data?.reciever_id) {
            console.log(data)
            dispatch(slice.actions.notify({ notify_content: `Bạn đang có một ticket gần hết hạn, vào lúc ${data?.date_end} !` }))
            dispatch(slice.actions.refreshNotify())

        }
    })
    /// New Producer
    // io.on("read-message-facebook", (data) => {
    //     dispatch(updateStatusReadMessage(data));
    // });
    io.on("fb-post-recieve", (data) => {
        notify_audio_facebook();
        dispatch(receiPostFromWebhookFacebook(data));
    });
    /// Consumers
    io.on("fb-comment-recieve", (data) => {
        notify_audio_facebook();
        dispatch(receiCommentFromWebhookFacebook(data));
    });
    ///
    io.on("fb-comment-reply-recieve", (data) => {
        console.log(data)
        notify_audio_facebook();
        dispatch(receiCommentRepliesFromWebhookFacebook(data));
    });
    io.on("noti-guest-connect-user", (data) => {
        console.log(data)
        dispatch(onEventGuestConnectUser(data));
    });
    io.on("noti-guest-disconnect-user", (data) => {
        console.log(data)
        dispatch(onRemoveQueue(data));
    });
    io.on("receive_msg", (data) => {
        dispatch(onEventReceiveMessage(data));
    });
    io.on("join_chat", (data) => {
        dispatch(onEventJoinChat(data));
        dispatch(onRemoveQueue(data));
    });
    /// New Peer
    io.on("newPeer", (data) => {

    });

    /// Call
    io.on("call", (data) => {

    });

    io.on("call-busy", (data) => { });

    /// Close
    io.on("close", async (data) => {

    });

    /// Answer
    io.on("answer", (data) => {

    });

    /// Remove
    io.on("remove", (data) => {

    });

    /// Online users
    io.on("onlineUsers", (data) => {

    });

    /// Refresh Meetings
    io.on("refresh-meetings", (data) => {
    });

    io.on("disconnected", () => { });
    io.on("create-group", (data) => {

    });
    window.onbeforeunload = function () {
        io.emit("leave", {});
        return;
    };
    return () => {
        io.on("disconnected", () => { });
    }
};
